export default {
  heading: 'Raleway',
  body: 'Raleway',
  monospace: 'Menlo, monospace',
  display: 'Raleway',
  googleFonts: ['Raleway:100,200,300,400,500,600,700,800,900']
  // customFamilies: [''],
  // customUrls: [''],
}
